import { gql } from '@apollo/client';

/**
 * Move the anchors a norm set is measured from.
 *
 * `anchors` and `normSet` are written in the same patch, and that is the whole
 * point of this mutation. Every `mean_dist` in the row was measured *from* the
 * anchors, so new anchors beside old distances would be a hundred numbers
 * describing a comparison that was never made. Two mutations could leave the
 * row in exactly that state if the second one failed.
 *
 * Membership does not appear here as a decision: the same products stay in the
 * set and only their distances are recomputed. A different set of products is a
 * new norm set, not an edit of this one.
 */
export default gql`
  mutation UpdateNormSetAnchors(
    $id: Int!
    $patch: PerceptionModelProjectPatch!
  ) {
    updatePerceptionModelProjectById(
      input: { id: $id, perceptionModelProjectPatch: $patch }
    ) {
      perceptionModelProject {
        id
        name
        anchors
        normSet
        perceptionModelJobId
        producerId
        createdDate
      }
    }
  }
`;
